import classNames from 'classnames';
import { TextareaHTMLAttributes } from 'react';

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
    onChangeValue: (text: string) => void;
};

export function Textarea({
    onChangeValue,
    className,
    ...props
}: TextareaProps) {
    return (
        <textarea
            {...props}
            className={classNames(
                'h-[200px] p-10',
                'w-full resize-none',
                'text-body text-grey',
                'border-[1px] border-grey-textfield outline-none focus:border-[2px] focus:border-dark-red',
                'disabled:bg-cool-grey disabled:opacity-30',
                'read-only:pointer-events-none read-only:bg-cool-grey',
                'placeholder-cursive font-cursive placeholder-grey-textfield-placeholder placeholder:italic',
                className,
            )}
            onChange={(e) => onChangeValue(e.currentTarget.value)}
        />
    );
}
